import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  rank: [],
};

// Slice
const bestSellerSlice = createSlice({
  name: "bestSeller",
  initialState,
  reducers: {
    findRank() {},
    setRank(state, action) {
      const { rank } = action.payload;
      return { ...state, rank };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { findRank, setRank, fetchDataSuccess, fetchDataFailure } =
  bestSellerSlice.actions;

export default bestSellerSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl);

    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { rank } = response.data;
      yield put(setRank({ rank }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* bestSellerSaga() {
  yield takeLatest(findRank.type, fetchDataSaga);
}
